import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import Navbar from "../../Components/Navbar";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import { Button } from "../../Components/Styles/PageStyles";
import { Label } from "../../Components/Styles/InputStyles";
import { useSelector } from "react-redux";
import AddDues from "../../Components/Dues/AddDues";
import moment from "moment";
import Passbook from "../../Components/Tenants/Details/Passbook";
import { useLocation, useParams } from "react-router-dom";
import TenantInfo from "../../Components/Tenants/Details/TenantInfo";
import Documents from "../../Components/Tenants/Details/Documents";
import Loading from "../../Components/Loading";
import { TenantDetailsLoading } from "../../Components/SkeletonLoading";
//import { capitalizeFirstLetter } from "../../helpers/capitalizeFirstLetter";
import { MdDelete } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

import { capitalizeFirstLetter } from "../../helpers";

import {
  BoxContainer,
  Bg,
  Underline,
} from "../../Components/Styles/PageStyles";
import ViewDetailModel from "../../Components/Dues/ViewDetail";
import MarkAsPaidModel from "../../Components/Dues/MarkAsPaidModel";
// import MarkAsPaidModelTest from "../../Components/Dues/MarkAsPaidModelTest";


import DeleteModal from "../../Components/DeleteModal";
import TenantDeleteModal from "../../Components/TenantDeleteModal";
import AddDuesModal from "../../Components/Dues/AddDuesModal";
// import AddAssets from "../../Components/Dues/AddAssets";

const TenantDetails = () => {
  const { id } = useParams();
  // const { clientId } = useParams();
  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [isMarkAsPaidVisible, setIsMarkAsPaidVisible] = useState(false);
  const [isAddDuesModal, setIsAddDuesModal] = useState(false);
  const [isAddAssetModal, setIsAddAssetModal] = useState(false);


  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  // const [apiData, setApiData] = useState();

  const [addDues, setAddDues] = useState(false);
  const [activeStep, setActiveStep] = useState("Tenant Info");
  const [personalDetails, setPersonalDetails] = useState({});

  const [goTo, setGoto] = useState(location?.state?.tabKey || "Tenant Info");

  const today = moment().format("YYYY-MM-DD");
  // const initialTenantData = location?.state?.data || {};
  // const [tenantData, setTenantData] = useState(initialTenantData);
  const tabName = location?.state?.tabName || "Tenant Info";
  // const tabKey = location?.state?.tabKey || "Tenant Info";
  const navigate = useNavigate();

  // transactions data
  const fetchTenantDetailsFunction = async () => {
    const body = new FormData();
    body.append("tenantId", id);
    return await axios.post(`${Config.apiUrl}/gettenantdetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const {
    isLoading: isLoading,
    mutate: getTenantDetailsMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchTenantDetailsFunction, {});

  useEffect(() => {
    getTenantDetailsMutate();
  }, []);

  // console.log (data?.data?.tenant)

  // Function to handle button click
  const handleButtonClick = (step) => {
    setActiveStep(step);
  };

  // Function to handle Rent Detail form submission
  const editRentDetailFunction = async (values) => {
    // console.log("API function called with values:", values);
    const body = new FormData();
    body.append("tenantId", id);
    body.append("rent", values.rent);
    body.append("moveInDate", values.moveInDate);
    body.append("rentalCycle", values.rentalCycle);
    body.append("agreementPeriod", values.agreementPeriod);
    body.append("lockInPeriod", values.lockInPeriod);
    body.append("noticePeriod", values.noticePeriod);
    body.append("moveOutDate", values.moveOutDate);

    return await axios.post(`${Config.apiUrl}/editrentdetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getRentDetailSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Rent Details successfully Updated.");
    }
  };

  const getRentDetailError = (res) => { };

  const { isLoading: isRentDetailLoading, mutate: addRentDetailMutate } =
    useMutation(editRentDetailFunction, {
      onSuccess: getRentDetailSuccess,
      onError: getRentDetailError,
    });

  // Function to handle Personal Detail form submission
  const editPersonalDetailFunction = async (values) => {
    const body = new FormData();
    body.append("tenantId", id);
    body.append("name", values.name);
    body.append("mobile", values.mobile);
    body.append("email", values.email);
    body.append("gender", values.gender);
    body.append("occupation", values.occupation);
    body.append("dob", values.dob);
    body.append("address", values.address);
    body.append("nationality", values.nationality);
    body.append("alternateMobile", values.alternateMobile);
    body.append("monthlyIncome", values.monthlyIncome);

    return await axios.post(`${Config.apiUrl}/edittenant`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getPersonalDetailSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Tenant Info successfully Updated.");
    }
  };

  const getPersonalDetailError = (res) => { };

  const {
    isLoading: isPersonalDetailLoading,
    mutate: addPersonalDetailMutate,
  } = useMutation(editPersonalDetailFunction, {
    onSuccess: getPersonalDetailSuccess,
    onError: getPersonalDetailError,
  });

  // Function to handle Guardian Detail form submission
  const editGuardianDetailFunction = async (values) => {
    const body = new FormData();
    body.append("tenantId", id);
    body.append("fatherName", values.fatherName);
    body.append("fatherMobile", values.fatherMobile);
    body.append("fatherOccupation", values.fatherOccupation);
    body.append("fatherAnnualIncome", values.fatherAnnualIncome);
    body.append("motherName", values.motherName);
    body.append("motherMobile", values.motherMobile);
    body.append("localGuardian", values.localGuardian);
    body.append("guardianMobile", values.guardianMobile);
    body.append("guardianRelationship", values.guardianRelationship);

    return await axios.post(`${Config.apiUrl}/editguardiandetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getGuardianDetailSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Tenant Info successfully Updated.");
    }
  };

  const getGuardianDetailError = (res) => { };

  const {
    isLoading: isGuardianDetailLoading,
    mutate: addGuardianDetailMutate,
  } = useMutation(editGuardianDetailFunction, {
    onSuccess: getGuardianDetailSuccess,
    onError: getGuardianDetailError,
  });

  // Function to handle Occupation Detail form submission
  const editOccupationDetailFunction = async (values) => {
    const body = new FormData();
    body.append("tenantId", values.id);
    body.append("occupationDetails", values.occupationDetails);
    body.append("companyName", values.companyName);
    body.append("hrContact", values.hrContact);
    body.append("workAddress", values.workAddress);
    body.append("monthlyIncome", values.monthlyIncome);
    body.append("incomeSource", values.incomeSource);

    return await axios.post(`${Config.apiUrl}/editoccupationdetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getOccupationDetailSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Tenant Info successfully Updated.");
    }
  };

  const getOccupationDetailError = (res) => { };

  const {
    isLoading: isOccupationDetailLoading,
    mutate: addOccupationDetailMutate,
  } = useMutation(editOccupationDetailFunction, {
    onSuccess: getOccupationDetailSuccess,
    onError: getOccupationDetailError,
  });

  // Function to handle Tenant Deletion

  const deleteTenant = async () => {
    const body = new FormData();
    body.append("tenantId", id);
    return await axios.post(`${Config.apiUrl}/deletetenant`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onDeleteTenantSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Deleted Successfully");
      setIsDeleteModalVisible(false);
      navigate("/tenants");
    }
  };

  const onDeleteTenantError = (res) => { };

  const { isLoading: isdeleteTenantLoading, mutate: deleteTenantMutate } =
    useMutation(deleteTenant, {
      onSuccess: onDeleteTenantSuccess,
      onError: onDeleteTenantError,
    });

  // const addAssetFunction = async (values) => {
  //   const body = new FormData();
  //   console.log("asset", values);
  //   body.append("assetType", values.assetType);
  //   body.append("assetSubType", values.assetSubType);
  //   body.append("quantity", values.quantity);
  //   body.append("serialNumber", values.serialNumber);

  //   return await axios.post(`${Config.apiUrl}/addasset`, body, {
  //     headers: {
  //       authorization: "Bearer" + " " + user.token,
  //       "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  //     },
  //   });
  // };

  // const addAssetFunctionSuccess = (data) => {
  //   if (data?.data?.status === "OK") {
  //     toast.success(data?.data?.msg || "Asset data successfully successfully Updated.");
  //   }
  // };

  // const addAssetFunctionError = (res) => { };

  // const {
  //   isLoading: isaddAssetLoading,
  //   mutate: addAssetFunctionMutate,
  // } = useMutation(addAssetFunction, {
  //   onSuccess: addAssetFunctionSuccess,
  //   onError: addAssetFunctionError,
  // });

  // console.log("clientId", data?.data?.data?.dues[0]?.clientId);

  const getStatus = (status) => {
    if (status === 1) {
      return <Unverified>Unverified</Unverified>;
    } else if (status === 2) {
      return <Vaccines>Vacant</Vaccines>;
    } else if (status === 3) {
      return <Linked>Linked</Linked>;
    } else if (status === 4) {
      return <Requested>Requested</Requested>;
    } else if (status === 5) {
      return <Occupied>Occupied</Occupied>;
    } else if (status === 6) {
      return <Moving>Moving Out</Moving>;
    } else if (status === 7) {
      return <Reserved>Reserved</Reserved>;
    } else {
      return "Invalid Status";
    }
  };

  useEffect(() => {
    setActiveStep(tabName);
  }, [tabName]);

  return (
    <Bg
      style={{
        backgroundImage: `url(${Images.BeamsBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "top left",
        height: "100vh",
      }}
    >
      <Navbar />

      <BoxContainer>
        {!error && !isLoading && data && (
          <Wrapper>
            <div className="flex flex-wrap justify-between items-center mb-6 gap-6">
              <div className="flex flex-wrap items-center gap-4 sm:w-auto w-full">
                <img
                  src={Images.Avatar}
                  alt="Tenant Profile"
                  className="w-16 h-16 rounded-full"
                />
                <div className="flex flex-col w-full sm:w-auto">
                  <div className="flex flex-wrap items-center gap-2">
                    <h2 className="text-xl font-semibold text-zinc-900">
                      {capitalizeFirstLetter(data?.data?.tenantName)}
                    </h2>
                    <span className="ml-2">
                      {getStatus(data?.data?.tenant?.status)}
                    </span>
                  </div>
                  <div className="mt-0 flex flex-wrap gap-8">
                    <div>
                      <Label className="font-medium">Room No.</Label>
                      <p className="text-md text-gray-800 font-medium">
                        #{data?.data?.roomNum + "," + data?.data?.flatName}
                      </p>
                    </div>

                    <div>
                      <Label className="font-medium">Property Name</Label>
                      <p className="text-md text-gray-800 font-medium">
                        {data?.data?.propertyName}
                      </p>
                    </div>

                    <div>
                      <Label className="font-medium">Total Collection</Label>
                      <p
                        className="text-md text-green-500 font-medium"
                        onClick={() => {
                          setGoto("totalTransaction");
                          setActiveStep("Passbook");
                        }}
                      >
                        ₹{data?.data.totalTransaction}
                      </p>
                    </div>

                    <div>
                      <Label className="font-medium">Total Dues</Label>
                      <p
                        className="text-md text-red-500 font-medium"
                        onClick={() => {
                          setGoto("totalDues");
                          setActiveStep("Passbook");
                        }}
                      >
                        ₹{data?.data?.totalDues}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* trial for delete action */}
              {/* <UploadWrapper>
                <div className="flex justify-end w-full mt-4">
                  <MdDelete
                    className="text-red-500 cursor-pointer"
                    size={24}
                    onClick={() => {
                      setIsDeleteModalVisible(true);
                    }}
                  />
                </div>
              </UploadWrapper> */}

              <UploadWrapper>
                {/* <Button type="button" onClick={() => setAddDues(true)}>
                  <p className="text-sm">{"Add Dues"}</p>
                </Button> */}
                {/* <Button type="button" onClick={() => setIsAddAssetModal(true)}>
                  <p className="text-sm">{"Add Assets"}</p>
                </Button> */}
                <Button type="button" onClick={() => setIsAddDuesModal(true)}>
                  <p className="text-sm">{"Add Dues"}</p>
                </Button>
                <button
                  className="flex items-center justify-center"
                  onClick={() => setIsDeleteModalVisible(true)}
                >
                  <MdDelete className="text-gray-500" size={32} />
                  {/* <RiDeleteBin6Line size={24} /> */}
                </button>
              </UploadWrapper>
            </div>

            {addDues && (
              <AddDues
                // addDuesMutate={addDuesMutate}
                // addDuesLoading={addDuesLoading}
                setAddDues={setAddDues}
                // data={data?.data}
                selectedData={selectedData}
              />
            )}
            <hr className="border-b border-gray-100" />

            <div className="flex flex-col-2">
              <FieldWrapper>
                {/* Jump Button Section */}
                <div className="mx-auto pb-4 px-4">
                  <div className="flex flex-wrap items-center gap-4 ">
                    {["Tenant Info", "Passbook", "Documents"].map((step) => (
                      <div key={step} className="flex flex-col items-center">
                        <button
                          className={`w-fit px-4 h-8 rounded-full shadow text-sm font-medium ${activeStep === step
                            ? "bg-zinc-800 text-zinc-100"
                            : "bg-gray-200 text-gray-600"
                            }`}
                          onClick={() => handleButtonClick(step)}
                        >
                          {step}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-wrap md:flex-nowrap gap-6 pr-4 overflow-y-auto">
                  <div className="w-full ml-1">
                    {activeStep === "Tenant Info" && (
                      <>
                        <TenantInfo
                          data={data?.data}
                          addRentDetailMutate={addRentDetailMutate}
                          addPersonalDetailMutate={addPersonalDetailMutate}
                          addGuardianDetailMutate={addGuardianDetailMutate}
                          addOccupationDetailMutate={addOccupationDetailMutate}
                          isRentDetailLoading={isRentDetailLoading}
                          isPersonalDetailLoading={isPersonalDetailLoading}
                          isGuardianDetailLoading={isGuardianDetailLoading}
                          isOccupationDetailLoading={isOccupationDetailLoading}
                        />
                      </>
                    )}

                    {activeStep === "Passbook" && (
                      <>
                        <Passbook
                          data={data?.data}
                          goTo={goTo}
                          setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
                          isMarkAsPaidVisible={isMarkAsPaidVisible}
                        />
                      </>
                    )}

                    {activeStep === "Documents" && (
                      <>
                        <Documents tenantData={data?.data?.data?.documents} />
                      </>
                    )}
                  </div>
                </div>
              </FieldWrapper>
            </div>
          </Wrapper>
        )}

        <div
          className={`${isMarkAsPaidVisible ? "flex" : "hidden"
            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
          onClick={() => setIsMarkAsPaidVisible(null)}
        />
        <div
          className={`${isMarkAsPaidVisible
            ? "translate-x-0 opacity-100"
            : "translate-x-full opacity-0"
            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
        >
          {isMarkAsPaidVisible && (
            <MarkAsPaidModel
              collectionDate="2023-12-01"
              partialPayment="500"
              paymentMode="Cash"
              transactionId="TXN12345"
              setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
              MarkAsPaidLoading={true}
              additionalFields={{
                notes: "Payment for December invoice",
              }}
              excessAmount=""
              partialAmount=""
            />
          )}
        </div>
        {/* Add Dues Modal */}
        <div
          className={`${isAddDuesModal ? "flex" : "hidden"
            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
          onClick={() => setIsAddDuesModal(null)}
        />
        <div
          className={`${isAddDuesModal
            ? "translate-x-0 opacity-100"
            : "translate-x-full opacity-0"
            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
        >
          {isAddDuesModal && (
            <AddDuesModal
              collectionDate="2023-12-01"
              partialPayment="500"
              paymentMode="Cash"
              transactionId="TXN12345"
              setIsAddDuesModal={setIsAddDuesModal}
              MarkAsPaidLoading={true}
              additionalFields={{
                notes: "Payment for December invoice",
              }}
              excessAmount=""
              partialAmount=""
            />
          )}
        </div>
        {/* Add Assets Modal */}
        {/* <div
          className={`${isAddAssetModal ? "flex" : "hidden"
            } fixed inset-0 h-screen w-screen bg-black/30 backdrop-blur-sm transition-all duration-800 ease-in-out`}
          onClick={() => setIsAddAssetModal(null)}
        />
        <div
          className={`${isAddAssetModal
            ? "translate-x-0 opacity-100"
            : "translate-x-full opacity-0"
            } fixed h-screen right-0 top-0 transition-all duration-800 ease-in-out bg-white flex items-start md:rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
        >
          {isAddAssetModal && (
            <AddAssets
              addAssetFunctionMutate={addAssetFunctionMutate}
              isaddAssetLoading={isaddAssetLoading}
            />
          )}
        </div> */}


        {isDeleteModalVisible && (
          <TenantDeleteModal
            deleteMutate={deleteTenantMutate}
            isdeleteTenantLoading={isdeleteTenantLoading}
            setDelete={setIsDeleteModalVisible}
          />
        )}

        {(isLoading || isRefetching) && <TenantDetailsLoading />}
      </BoxContainer>
    </Bg>
  );
};

// const BoxContainer = tw.div`Container md:mt-8   mx-auto p-6 bg-white rounded-lg shadow-lg`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
// const UploadWrapper = tw.div` flex justify-end space-x-4 items-center `;
const UploadWrapper = tw.div`flex items-center gap-3 `;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const Wrapper = tw.div`px-1 space-y-4`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
const SubmitBtn = tw.button`text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-full shadow-md`;
const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;

const Unverified = tw.div`bg-yellow-500 text-white text-xs font-normal px-2 w-auto h-4 flex items-center justify-center rounded-full`;
const Vaccines = tw.div`bg-blue-500 text-white  text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const Requested = tw.div`bg-lime-500 text-white  text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const Occupied = tw.div`bg-green-500 text-white  text-xs px-2 w-auto h-4 flex items-center justify-center rounded-full`;
const Reserved = tw.div`bg-orange-500 text-white  text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const Linked = tw.div`bg-purple-500 text-white  text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const Moving = tw.div`bg-rose-500 text-white  text-xss font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;

export default TenantDetails;
